const ClockPrimary = (props) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
      fill="#335683"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6a1 1 0 0 1 1 1v4.586l2.207 2.207a1 1 0 0 1-1.414 1.414L11.586 13A2 2 0 0 1 11 11.586V7a1 1 0 0 1 1-1Z"
      fill="#335683"
    />
  </svg>
);

export default ClockPrimary;
